import Filter from "./Filter.js";

function PatientFilter( {onClick, isClicked} ) {
    return (
      <Filter onClick={onClick} isClicked={isClicked} text={"Pazienti"}/>
    );
  }
  
  export default PatientFilter;